import { Box, CircularProgress } from '@mui/material';
import React from 'react';

interface LoadingPageProps {
  minHeight?: string | number;
}

const LoadingPage: React.FC<LoadingPageProps> = ({ minHeight = '100%' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight,
        width: '100%',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingPage;
